export const getJobApprovals = (state) => {
  return state.jobApprovals;
};


export const getCurrentJobId = (state) => {
  const { currentJobId } = getJobApprovals(state);
  return currentJobId;
};


export const getCurrentDistrictId = (state) => {
  const { currentDistrictId } = getJobApprovals(state);
  return currentDistrictId;
};


export const getCurrentDepartmentId = (state) => {
  const { currentDepartmentId } = getJobApprovals(state);
  return currentDepartmentId;
};


export const getCurrentTicketId = (state) => {
  const { currentTicketId } = getJobApprovals(state);
  return currentTicketId;
};
